import React from 'react';
import { Switch, Route } from 'react-router-dom';

import Terminais from '../../../modulos/terminalacesso/containers/Terminais';

class TerminaisNavegacao extends React.Component {
    render(){
        return (            
            <Switch>
                <Route exact path={`${this.props.match.path}/:promotora/:evento`} component={Terminais} />
            </Switch>
        )
    }
}

export default TerminaisNavegacao;